import { useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/common/PageHeader';
import PatientForm from '../components/patient/PatientForm';
import PatientSearch from '../components/common/PatientSearch';
import StartVisitModal from '../components/patient/StartVisitModal';
import { patientApi } from '../api';
import { useToast } from '../context/ToastContext';

export default function NewPatient() {
  const navigate = useNavigate();
  const toast = useToast();
  const [created, setCreated] = useState(null);

  async function handleSubmit(values) {
    try {
      const res = await patientApi.create(values);
      toast.success(`${res.data.name} registered as ${res.data.patientId}`);
      // Registration flows straight into sending the patient in.
      setCreated(res.data);
    } catch (err) {
      toast.error(err);
      throw err;
    }
  }

  return (
    <>
      <PageHeader
        title="Register New Patient"
        subtitle="Fill this only for someone visiting for the first time"
        icon="bi-person-plus-fill"
      >
        <Button variant="light" onClick={() => navigate('/queue')}>
          <i className="bi bi-arrow-left me-1" /> Back to Queue
        </Button>
      </PageHeader>

      <Alert variant="info" className="d-flex flex-column flex-md-row align-items-md-center gap-2">
        <div className="flex-shrink-0">
          <i className="bi bi-info-circle me-1" />
          <strong>Already been here before?</strong> Search instead of registering again:
        </div>
        <div className="flex-grow-1" style={{ minWidth: 260 }}>
          <PatientSearch onSelect={(p) => navigate(`/patients/${p._id}`)} placeholder="Search existing patient..." />
        </div>
      </Alert>

      <PatientForm onSubmit={handleSubmit} onPickExisting={(p) => navigate(`/patients/${p._id}`)} />

      <StartVisitModal
        show={!!created}
        patient={created}
        onHide={() => {
          setCreated(null);
          navigate('/queue');
        }}
        onDone={() => navigate('/queue')}
      />
    </>
  );
}
